import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Carousel from 'react-multi-carousel';

import { MPopupHeader } from '../../molecules/MPopupHeader';
import PopupOfferActionButtons from '../../molecules/PopupOfferActionButtons';
import { MBox } from '../../atoms/MBox';
import MFlexbox from '../../atoms/MFlexbox';
import { MText } from '../../atoms/MText';
import { MDiscountCode } from '../../MDiscountCode';

import CarouselCustomDot from '../../molecules/CarouselCustomDot';
import CarouselCustomButtonGroup from '../../molecules/CarouselCustomButtonGroup';
import IconArrowBack from '../../atoms/IconArrowBack';
import IconArrowForward from '../../atoms/IconArrowForward';

const StyledCarouselWrapper = styled(MBox)`
  .mr-products-container-carousel {
    position: static;
  }

  .mr-products-container-carousel > .mr-products-container-carousel__dot-list {
    position: absolute;
    bottom: 0px;
    display: flex;
    padding: 10px 0px;

    .react-multi-carousel-dot {
      line-height: 1px;
    }

    .react-multi-carousel-dot.react-multi-carousel-dot--active button {
      background-color: ${props => props.carouselActionColor} !important;
    }

    .react-multi-carousel-dot button {
      padding: 0px !important;
      background-color: transparent !important;
      min-height: 10px;
      height: 10px;
      min-width: 10px !important;
      width: 10px !important;
      border-color: ${props => props.carouselActionColor} !important;
    }
  }

  & > .mr-products-container-carousel__arrows {
    & .react-multiple-carousel__arrow {
      background: none;
      min-height: 0px;
      min-width: 0px;
      bottom: 5px;

      &:hover {
        background: none;
      }

      &::before {
        content: none;
      }

      &--right {
        right: 16px;
      }

      &--left {
        left: 16px;
      }
    }
  }
`;

export default function PopupCrossSellOfferCon(props) {
  const {
    renderInCarousel,
    popupOfferHeaderStyles,
    popupOfferBottomBarStyles: {
      bottomBarContainerBackgroundColor,
      bottomBarContainerPadding,
      bottomBarContainerMargin,
      carouselActionColor,
      ...restPopupOfferBottomBarStyles
    },
    onMinimizeClick,
    onCheckoutClick,
    onSkipClick,
    children,
    productsContainerPadding,
    productsContainerMargin,
    showDiscountCode,
    discountCodeProps,
    isBottomBarButtonActionLoading,
    offerLevelQuantityAdded,
    offerLevelDiscountQuantity,
    atcStatus,
  } = props;

  const responsive = {
    any: {
      breakpoint: { max: 5000, min: 0 },
      items: 1,
    },
  };

  const showDots = renderInCarousel && children.length > 1;

  let offerHeaderCopy = popupOfferHeaderStyles.offerHeaderText;
  offerHeaderCopy = offerHeaderCopy
    .replace('{{added_count}}', `${offerLevelQuantityAdded.toString()}`)
    .replace('{{total_count}}', `${offerLevelDiscountQuantity.toString()}`);

  popupOfferHeaderStyles.offerHeaderText = offerHeaderCopy;

  return (
    <>
      <MPopupHeader
        {...popupOfferHeaderStyles}
        onMinimizeClick={onMinimizeClick}
      />
      {renderInCarousel ? (
        <>
          <StyledCarouselWrapper
            backgroundColor={bottomBarContainerBackgroundColor}
            padding={productsContainerPadding}
            margin={productsContainerMargin}
            carouselActionColor={carouselActionColor}
            className="mr-popup-widget__products-container"
          >
            <Carousel
              showDots={showDots}
              arrows={false}
              responsive={responsive}
              className="mr-products-container-carousel mr-products-container-carousel--with-dots"
              dotListClass="mr-products-container-carousel__dot-list"
              customDot={<CarouselCustomDot />}
              renderButtonGroupOutside
              customButtonGroup={
                <CarouselCustomButtonGroup
                  prevButton={
                    <MFlexbox>
                      <IconArrowBack
                        fontSize="20"
                        color={carouselActionColor}
                      />
                    </MFlexbox>
                  }
                  nextButton={
                    <MFlexbox gap="6px">
                      <IconArrowForward
                        fontSize={20}
                        color={carouselActionColor}
                      />
                    </MFlexbox>
                  }
                />
              }
            >
              {children}
            </Carousel>
          </StyledCarouselWrapper>
          {showDots && (
            <MBox
              backgroundColor={bottomBarContainerBackgroundColor}
              className="mr-popup-widget__navigation-con"
              padding="30px 0px 0px 0px"
            />
          )}
        </>
      ) : (
        <>
          <MBox
            backgroundColor={bottomBarContainerBackgroundColor}
            padding={productsContainerPadding}
            margin={productsContainerMargin}
            className="mr-popup-widget__products-container"
          >
            {children}
          </MBox>
          <MBox
            backgroundColor={bottomBarContainerBackgroundColor}
            padding={bottomBarContainerPadding}
            margin={bottomBarContainerMargin}
            className="mr-popup-widget__bottom-bar-con"
          >
            {showDiscountCode && <MDiscountCode {...discountCodeProps} />}
            <PopupOfferActionButtons
              {...restPopupOfferBottomBarStyles}
              showShoppingCartIcon
              onPrimaryClick={onCheckoutClick}
              onSecondaryClick={onSkipClick}
              layout={
                restPopupOfferBottomBarStyles.bottomBarPrimaryButtonWidthStyle ===
                'fullWidth'
                  ? 'vertical'
                  : 'horizontal'
              }
              isActionsOrderReversed={
                restPopupOfferBottomBarStyles.bottomBarPrimaryButtonWidthStyle ===
                'fullWidth'
              }
              isBottomBarButtonActionLoading={isBottomBarButtonActionLoading}
              atcStatus={atcStatus}
            />
          </MBox>
        </>
      )}
    </>
  );
}

PopupCrossSellOfferCon.propTypes = {
  children: PropTypes.node,
  popupOfferHeaderStyles: PropTypes.object,
  popupOfferBottomBarStyles: PropTypes.object,
  isMobile: PropTypes.bool,
  renderInCarousel: PropTypes.bool,
  onMinimizeClick: PropTypes.func,
  onCheckoutClick: PropTypes.func,
  onSkipClick: PropTypes.func,
  productsContainerPadding: PropTypes.string,
  productsContainerMargin: PropTypes.string,
  showDiscountCode: PropTypes.bool,
  discountCodeProps: PropTypes.object,
  isBottomBarButtonActionLoading: PropTypes.bool,
  offerLevelQuantityAdded: PropTypes.number,
  offerLevelDiscountQuantity: PropTypes.number,
  atcStatus: PropTypes.string,
};
